module.exports = __webpack_public_path__ + "static/img/logo_text_b.099b1961.png";